import { formatDate } from '../../../utility/dateUtils';
import { WORKSPACE_MAP } from '../jobPostingDetailsPage/config';

const DATE_FORMAT = 'dd MMM yyyy';

export const getJobItemsFirstPart = (translations, job) => ({
  [translations.jobTitle]: job.title,
  [translations.location]: job.location,
  [translations.workspace]:
    Object.values(WORKSPACE_MAP).find(
      workspace => workspace.id === job?.workspace
    )?.label || translations.noValue,
  [translations.dateEnd]: formatDate(job.date_to, DATE_FORMAT),
});
export const getJobItemsSecondPart = (translations, job) => ({
  [translations.description]: job.description,
  [translations.requirements]: job.requirements,
  [translations.benefits]: job.benefits,
});
